<!-- No celular, a sidebar e um drawer por cima do conteudo - esse fundo
     escurecido some no desktop (ver .mobile-drawer-backdrop em sidebar.css)
     e no celular fecha o menu ao tocar fora dele. -->
<div
  class="mobile-drawer-backdrop"
  *ngIf="!(sidebarState.collapsed$ | async)"
  (click)="sidebarState.toggle()"
></div>

<div class="sidebar" [class.collapsed]="sidebarState.collapsed$ | async">
  <button
    type="button"
    class="sidebar-toggle"
    [attr.aria-label]="(sidebarState.collapsed$ | async) ? 'Expandir menu' : 'Recolher menu'"
    (click)="sidebarState.toggle()"
  >
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      [class.rotated]="sidebarState.collapsed$ | async"
    >
      <polyline points="15 6 9 12 15 18"></polyline>
    </svg>
  </button>

  <div class="sidebar-logo">
    <img
      src="/logo-monitoricore.png"
      alt="MonitoriCore"
      class="logo-image"
    />
  </div>

  <!-- <div class="sidebar-title">Menu</div> -->

  <nav class="sidebar-nav">
    <ng-container *ngFor="let item of menuItems">

      <!-- ITEM COM SUBMENU -->
      <ng-container *ngIf="item.children; else itemNormal">
        <div
          class="nav-group"
          (mouseenter)="onItemMouseEnter($event, item)"
          (mouseleave)="onItemMouseLeave()"
        >
          <div
            class="nav-group-title clickable"
            [class.active]="isGrupoAtivo(item)"
            (click)="onGrupoClick($event, item)">
            <svg class="nav-icon" viewBox="0 -960 960 960" fill="currentColor" *ngIf="item.icon as ic">
              <path [attr.d]="icons[ic]"></path>
            </svg>
            <span class="nav-label">{{ item.label }}</span>
            <!-- poder -->
          </div>

          <!-- Acordeão normal (menu aberto) - com o menu recolhido, a
               navegação acontece pelo flyout renderizado no fim do arquivo. -->
          <div *ngIf="item.expanded && !(sidebarState.collapsed$ | async)" class="nav-submenu">
            <ng-container *ngFor="let child of item.children">
              <!-- Item sem rota (tela ainda não existe) sai como texto, não
                   como link: um <a> sem routerLink vira href morto e ainda
                   pinta de "ativo" em qualquer rota. -->
              <span *ngIf="!child.route; else subitemLink" class="nav-item nav-subitem sem-rota">
                <svg class="nav-icon" viewBox="0 -960 960 960" fill="currentColor" *ngIf="child.icon as ic">
                  <path [attr.d]="icons[ic]"></path>
                </svg>
                <span class="nav-label">{{ child.label }}</span>
              </span>

              <ng-template #subitemLink>
                <a
                  class="nav-item nav-subitem"
                  [routerLink]="child.route"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="child.exact ? { exact: true } : { exact: false }"
                >
                  <svg class="nav-icon" viewBox="0 -960 960 960" fill="currentColor" *ngIf="child.icon as ic">
                    <path [attr.d]="icons[ic]"></path>
                  </svg>
                  <span class="nav-label">{{ child.label }}</span>
                </a>
              </ng-template>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <!-- ITEM NORMAL -->
      <ng-template #itemNormal>
        <a
          class="nav-item"
          [routerLink]="item.route"
          routerLinkActive="active"
          [routerLinkActiveOptions]="item.exact ? { exact: true } : { exact: false }"
          (mouseenter)="onItemMouseEnter($event, item)"
          (mouseleave)="onItemMouseLeave()"
        >
          <svg class="nav-icon" viewBox="0 -960 960 960" fill="currentColor" *ngIf="item.icon as ic">
            <path [attr.d]="icons[ic]"></path>
          </svg>
          <span class="nav-label">{{ item.label }}</span>
        </a>
      </ng-template>

    </ng-container>
  </nav>
</div>

<!-- Backdrop transparente: no toque (sem hover), o flyout so abre/fecha por
     clique (ver onGrupoClick) - sem isso ele ficaria preso aberto no celular,
     ja que não existe mouseleave em touch. -->
<div
  *ngIf="(sidebarState.collapsed$ | async) && hoveredItem"
  class="sidebar-flyout-backdrop"
  (click)="fecharFlyout()"
></div>

<!-- Flyout de navegação do menu recolhido. Fica FORA da ".sidebar" de
     propósito: a sidebar tem overflow-x/y para rolagem da lista de itens, o
     que cortaria qualquer conteúdo posicionado além da largura recolhida. -->
<div
  *ngIf="(sidebarState.collapsed$ | async) && hoveredItem as item"
  class="sidebar-flyout"
  [style.top.px]="flyoutTop"
  [style.left.px]="flyoutLeft"
  (mouseenter)="onFlyoutMouseEnter()"
  (mouseleave)="onFlyoutMouseLeave()"
>
  <div class="sidebar-flyout-title" *ngIf="item.children">{{ item.label }}</div>

  <ng-container *ngIf="item.children; else flyoutItemUnico">
    <ng-container *ngFor="let child of item.children">
      <span *ngIf="!child.route; else flyoutSubitemLink" class="sidebar-flyout-link sem-rota">
        <svg class="nav-icon" viewBox="0 -960 960 960" fill="currentColor" *ngIf="child.icon as ic">
          <path [attr.d]="icons[ic]"></path>
        </svg>
        {{ child.label }}
      </span>

      <ng-template #flyoutSubitemLink>
        <a
          class="sidebar-flyout-link"
          [routerLink]="child.route"
          routerLinkActive="active"
          [routerLinkActiveOptions]="child.exact ? { exact: true } : { exact: false }"
          (click)="fecharFlyout()"
        >
          <svg class="nav-icon" viewBox="0 -960 960 960" fill="currentColor" *ngIf="child.icon as ic">
            <path [attr.d]="icons[ic]"></path>
          </svg>
          {{ child.label }}
        </a>
      </ng-template>
    </ng-container>
  </ng-container>

  <ng-template #flyoutItemUnico>
    <a
      class="sidebar-flyout-link"
      [routerLink]="item.route"
      routerLinkActive="active"
      [routerLinkActiveOptions]="item.exact ? { exact: true } : { exact: false }"
      (click)="fecharFlyout()"
    >
      <svg class="nav-icon" viewBox="0 -960 960 960" fill="currentColor" *ngIf="item.icon as ic">
        <path [attr.d]="icons[ic]"></path>
      </svg>
      {{ item.label }}
    </a>
  </ng-template>
</div>
